export const HEADER_MENUS_CLOSE_EVENT = 'khayr:close-header-menus';

export const closeHeaderMenus = () => {
  window.dispatchEvent(new CustomEvent(HEADER_MENUS_CLOSE_EVENT));
};
